<template>
  <div class="strategies-view container fluid">
    <v-card>
      <StrategiesTrancheUtilizationTable />
    </v-card>
  </div>
</template>

<script>
import StrategiesTrancheUtilizationTable from '@/components/settlements/StrategiesTrancheUtilizationTable';

export default {
  name: 'StrategiesTrancheUtilizationView',
  components: {
    StrategiesTrancheUtilizationTable,
  },
  data() {
    return {

    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settlements/StrategiesTrancheUtilizationView.vue